(function () {
  var STORAGE_KEY = 'exitIntentPopupShown';
  var MIN_TIME_ON_PAGE_MS = 5000;
  var pageLoadTime = Date.now();

  function initExitIntentPopup() {
    var popup = document.getElementById('ExitIntentPopup');
    if (!popup) return;
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') return;

    function showPopup() {
      if (sessionStorage.getItem(STORAGE_KEY) === 'true') return;
      if (Date.now() - pageLoadTime < MIN_TIME_ON_PAGE_MS) return;
      popup.classList.add('exit-popup--visible');
      popup.setAttribute('aria-hidden', 'false');
      sessionStorage.setItem(STORAGE_KEY, 'true');
      document.removeEventListener('mouseout', handleMouseOut);
    }

    function hidePopup() {
      popup.classList.remove('exit-popup--visible');
      popup.setAttribute('aria-hidden', 'true');
    }

    function handleMouseOut(event) {
      if (!event.toElement && !event.relatedTarget && event.clientY <= 0) {
        showPopup();
      }
    }

    document.addEventListener('mouseout', handleMouseOut);

    popup.querySelectorAll('[data-exit-popup-close]').forEach(function (el) {
      el.addEventListener('click', hidePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hidePopup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExitIntentPopup);
  } else {
    initExitIntentPopup();
  }
})();
